// Tech.js
import React, { useEffect, useRef, useState } from 'react';
import './Tech.css';

// Importing icons from react-icons
import { FaReact, FaNodeJs, FaHtml5, FaCss3Alt, FaJsSquare, FaPython, FaGitAlt, FaDatabase } from 'react-icons/fa';
import { SiMongodb, SiDjango, SiTypescript, SiRedux } from 'react-icons/si';

function Tech() {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  // List of technologies with their corresponding icons
  const technologies = [
    { name: 'React', icon: <FaReact /> },
    { name: 'Node.js', icon: <FaNodeJs /> },
    { name: 'HTML5', icon: <FaHtml5 /> },
    { name: 'CSS3', icon: <FaCss3Alt /> },
    { name: 'JavaScript', icon: <FaJsSquare /> },
    { name: 'Python', icon: <FaPython /> },
    { name: 'MongoDB', icon: <SiMongodb /> },
    { name: 'Django', icon: <SiDjango /> },
    { name: 'TypeScript', icon: <SiTypescript /> },
    { name: 'Redux', icon: <SiRedux /> },
    { name: 'Git', icon: <FaGitAlt /> },
    { name: 'SQL', icon: <FaDatabase /> },
    // Add more technologies as needed
  ];

  useEffect(() => {
    const observerOptions = {
      root: null, // Relative to viewport
      rootMargin: '0px',
      threshold: 0.2, // 20% of the section is visible
    };

    const observerCallback = (entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        } else {
          setIsVisible(false);
        }
      });
    };

    const observer = new IntersectionObserver(observerCallback, observerOptions);

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    // Cleanup
    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section ref={sectionRef} className={`tech-section ${isVisible ? 'active' : ''}`}>
      <h2>Technologies I Use <span>.</span></h2>
      <div className="tech-grid">
        {technologies.map((tech, index) => (
          <div 
            key={index} 
            className="tech-item"
            style={{ animationDelay: `${index * 100}ms` }} // 100ms delay per item
            tabIndex="0" // Make focusable for accessibility
          >
            <div className="tech-icon">
              {tech.icon}
            </div>
            <p>{tech.name}</p>
            {/* Optional Tooltip */}
            {/* <span className="tooltip">{tech.description}</span> */}
          </div>
        ))}
      </div>
    </section>
  );
}

export default Tech;
 